var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Children, Component } from 'react';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, element, eventListener, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { PageEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isFunction, propagateProps } from '@philips-internal/oswald-ui-utils';
import RequestDataCollectorAPI from './request-data-collector-api.js';
const RequestDataCollectorContainer = {
    name: '',
};
let RequestDataCollector = class RequestDataCollector extends Component {
    constructor() {
        super(...arguments);
        this.onSubmit = ({ record }) => {
            const { onNextPage } = this.props;
            isFunction(onNextPage) && onNextPage(new PageEvent({ mergeParams: true, page: 0, params: record }));
        };
    }
    render() {
        const { children, uuid } = this.props;
        if (Children.count(children) === 0) {
            return React.createElement(Container, { className: "u-expand", uuid: uuid });
        }
        return (propagateProps(children, {
            onCancel: this.onSubmit,
            onSubmit: this.onSubmit,
        }));
    }
};
RequestDataCollector.propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    onNextPage: eventListener,
    uuid: string,
};
RequestDataCollector = __decorate([
    AwesomeComponent({ api: RequestDataCollectorAPI, containers: [RequestDataCollectorContainer], type: ComponentType.BEHAVIOR })
], RequestDataCollector);
export default RequestDataCollector;
//# sourceMappingURL=request-data-collector.js.map